import { useQuery } from "@tanstack/react-query";
import { ExportXlsx } from "../export-xlsx";

export const useExportResume = (filter: string) => {
  const { refetch } = useQuery({
    queryKey: ["Export"],
    queryFn: () => ExportXlsx("resume", filter),
    enabled: false,
  });

  return { refetch };
};
